export const RECEIVE_USER = "RECEIVE_USER"
export const SESSION_EXPIRED = "SESSION_EXPIRED"
export const UPDATE_USER = "UPDATE_USER"

export function receiveUser(user) {
  return {
    type: RECEIVE_USER,
    user,
  }
}

export function sessionExpired(user) {
  return {
    type: SESSION_EXPIRED,
    user,
  }
}

export function updateUser(user) {
  return {
    type: UPDATE_USER,
    user,
  }
}
